import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function Copyright(): React.JSX.Element {
  const today = new Date();
  const year = today.getFullYear();

  return (
    <Box className="max-md:mt-3 max-md:text-center">
      <Typography className="text-xs text-gray-04">&copy; 2013 - {year} wakuwaku Inc.</Typography>
    </Box>
  );
}
